import {StatisticsBarChart} from './StatisticsBarChart';
export default StatisticsBarChart;
